// extracted by mini-css-extract-plugin
export var borderRadius = "_69-4";
export var large = "_69-3";
export var logoContainer = "_69-0";
export var nameLogo = "_69-2";
export var small = "_69-1";